import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../assets/css/SlimSlider.css';
import {useState} from "react";
import {getSetting} from "../../services";
import {pushToast} from "../../utils/pushToast";
import {useEffect} from "react";

function ImageSlider() {
    const [dashboardSliderImages, setDashboardSliderImages] = useState([]);

    const getSettingData = async () => {
        try {
            const {data, result, status} = await getSetting();
            const images = data.dashboardSliderImages.filter(x => x.active);
            images.sort((a, b) => b.priority - a.priority);
            setDashboardSliderImages(images);
        } catch (ex) {
        }
    }
    useEffect(() => {
        getSettingData();

        // fetchTreeData();
    }, []);
    const settings = {
        rtl: true,
        dots: true, // Display dots for navigation
        infinite: true, // Loop the slider
        speed: 1000, // Transition speed in milliseconds
        slidesToShow: 1, // Number of slides to show at once
        slidesToScroll: 1, // Number of slides to scroll
        autoplay: true, // Autoplay the slider
        autoplaySpeed: 10000, // Autoplay speed in milliseconds
        className: "slides"
    };

    return (
        <div className="fullscreen-slider">

        <Slider  {...settings}>
            {dashboardSliderImages.map(x =>
                <div key={x.image} className="fullscreen-slide">
                    <div className="image-con">
                        <img className='img-start' src={x.image}/>
                    </div>
                </div>
            )}
        </Slider>
        </div>
    );
}

export default ImageSlider;